<style lang="less">
.pm-task {
  background: #ddd;
}

.pm-help {
  padding: 20px !important;
  font-size: 0.9rem;
  img {
    width: 100%;
  }
}
.in-app {
  background: #ddd;
}
</style>

<template>
  <App>
    <AppBar>
      <div class="flex-wrap">
        <TaskMenu />
        <TaskFileName v-model="task" />
      </div>
      <div class="flex-wrap">
        <IconTabs :items="views" :current="view" @on-select="view=$event" />
        <Divider type="vertical" />
        <IconButton :title="任务列表" icon="md-menu"  :active="showMenu" @on-click="showMenu = !showMenu" />
        <IconButton :title="作业指导" icon="md-help" :active="showHelper" @on-click="showHelper = !showHelper" style="margin-left:10px" />
      </div>
      <div class="flex-wrap split5">
        <AppAvatar />
        <Divider type="vertical" />
        <Button type="primary" @click="RouteTo('editor')">编辑</Button>
      </div>
    </AppBar>

    <AppMask v-if="!ready" />
    <AppLeft :collapse="!ready || !showMenu">

      <div class="flex-wrap" style="height:30px;padding:0 10px;">
        <Input />
      </div>
      <div style="height:calc(100% - 30px);border-top:1px solid #eee;">
        <BaseTree ref="tree" :data="[task]" manu style="height:100%" :nodeRenderer="renderTreeNode" @event="handleTreeEvent" />
      </div>
    </AppLeft>
    <AppRight :collapse="!ready || !showHelper">
      <BaseEmpty v-if="!selected.help" />
      <div class="pm-help" v-html="selected.help" style="padding:10px;white-space:pre-wrap;"></div>
    </AppRight>

    <AppClient :collapse-left="ready && showMenu" :collapse-right="ready && showHelper" v-if="ready">
      <transition name="fade">
        <template v-if="view == 'task'">
          <TaskContent v-model="selected" />
        </template>
        <template v-else-if="view == 'flow'">
          Flow
        </template>
        <template v-else-if="view == 'gantte'">
          <div>
            Gannte
          </div>
        </template>
        <template v-else-if="view == 'file'">
          <div>
            File
          </div>
        </template>
        <template v-else-if="view == 'share'">

          <TaskShare v-model="selected" />

        </template>
      </transition>

    </AppClient>

  </App>
</template>

<script>
import responsableMixin from '@/mixins/responsable';
import {mapGetters} from 'vuex';
import {Graph, Cell, CellView, Node} from '@antv/x6';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppMask from '@/components/app/mask';
import AppLeft from '@/components/app/left';
import AppRight from '@/components/app/right';
import AppClient from '@/components/app/client';
import AppAvatar from '@/components/app/avatar';
import IconButton from '@/components/app/IconButton';
import IconTabs from '@/components/app/IconTabs';
import TaskMenu from '@/components/task/app/bar/TaskMenu';
import TaskFileName from '@/components/task/app/bar/TaskFileName';
import TaskContent from '@/components/task/app/views/content';
import TaskShare from '@/components/task/app/views/share';
export default {
  components: {App, AppBar, AppLeft, AppRight, AppClient, AppAvatar, IconButton, IconTabs, TaskMenu, TaskFileName, TaskContent, TaskShare, AppMask},
  routerOption: {
    as_default: true,
  },
  data() {
    return {
      loading: false,
      selected: {},
      ready: false,
      showMenu: true,
      view: 'task',
      showHelper: true,

      task: {
        id: 5,
        width: 1920,
        height: 1080,
        name: '开工条件准备',
        subs: [{
          id: 51,
          name: '临时电',
          positions: ['机电', '技术', '前期'],
          content: `1、资料提交所属区供电单位后，等通知进行现场踏勘
2、现场踏勘需前期工程师、机电工程师陪同，踏勘主要确定供电接入点、临时箱变摆放位置等事宜。
3、确定临时箱变购买/租赁（需合约部签订合同）
备注：方案、踏勘可能会多次，后期方案可能需调整`,
          results: [{
            name: '临时供电答复单',
          }],
          help: `资料清单:
1、临时用电申请表（供电公司拿）
2、营业执照
3、立项文件
5、土地出让合同/划拨决定书
6、临电方案答复单（供电公司拿）
7、经办人身份证
  办理步骤
1、资料提交所属区供电单位后，等通知进行现场踏勘
2、现场踏勘需前期工程师、机电工程师陪同，踏勘主要确定供电接入点、临时箱变摆放位置等事宜。
3、确定临时箱变购买/租赁（需合约部签订合同）
备注：方案、踏勘可能会多次，后期方案可能需调整
  <Divider>联系单位</Divider>
XX区供电营业厅

  其他资料
1、<a href="https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/%E4%B8%B4%E6%B0%B4%E7%94%B3%E8%AF%B7%E6%89%AB%E6%8F%8F.pdf">方案答复单（样表）</a>
2、<a href="https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/%E4%B8%B4%E6%B0%B4%E7%94%B3%E8%AF%B7%E6%89%AB%E6%8F%8F.pdf">客户用电登记及相关资料</a>
          `,
          flow: {},
        }, {
          id: 52,
          name: '临时水',
          content: `1、资料提交所属区自来水单位后1-2个工作日内进行现场踏勘
2、现场踏勘需前期工程师、水电工程师陪同，踏勘主要确定现场进水点位事宜`,
          results: [{
            name: '临时水申请表',
            type: 'file',
            archived: true,
          }],
          help: `资料清单:
1、临时用水申请表（供水公司拿）
2、营业执照
3、立项文件
4、土地出让合同/划拨决定书
5、经办人身份证
  办理步骤
1、资料提交所属区自来水单位后1-2个工作日内进行现场踏勘。
2、现场踏勘需前期工程师、水电工程师陪同，踏勘主要确定现场进水点位事宜。
  其他资料
  <img src="https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/1670002767668.png" />
  <a href="https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/%E4%B8%B4%E6%B0%B4%E7%94%B3%E8%AF%B7%E6%89%AB%E6%8F%8F.pdf">临时水申请表（样表）</a>
          `,
        }, {
          id: 53,
          name: '申请道路开设',
          positions: ['前期', '合约'],
          content: `1、资料准备齐全提交所在XX区行政服务中心中心占道/挖掘窗口一份（城管），交警大队一份（一式三份）
2、联系各方现场踏勘
3、审批完成，现场施工
4、若涉及管线设备移位或永久拆除须签订协议或合同。
备注：承诺书模板通用`,
          subs: [{
            id: 55,
            name: '改绿',
            content: `1、承诺书
2、改变绿地性质
3、改变绿化规划、绿化用地的使用审批
1、2、3均向城管拿`,
          }, {
            id: 56,
            name: '挖掘',
            content: `1、承诺书
2、掘路项目计划表
3、挖掘表
4、挖掘申请材料告知单
5、委托书
1、3、4、5均向城管拿`,
          }, {
            id: 57,
            name: '占道',
            content: `1、临时占用城市道路审批材料告知单
2、委托书
1、2均向城管拿`,
          }, {
            id: 58,
            name: '占绿',
            content: `1、临时占绿表
2、承诺书
3、临时占用城市绿地审批材料告知单
4、委托书
1、2、3、4均向城管拿`,
          }, {
            id: 59,
            name: '监控、路灯移位',
            content: `1、申请表（无模板）
2、规划图
3、方案（移位、拆除方案）（无模板）
4、情况说明（无模板）
5、立项文件`,
          }],
        }],

      },
    };
  },
  mixins: [responsableMixin],
  props: {
    'panels': {
      type: Array,
      default: () => [],
    }, 'padding': {
      type: Number,
      default: 0,
    }, 'gutter': {
      type: Number,
      default: 10,
    }, 'env': {
      type: Object,
      default: () => ({}),
    }, 'flex': {
      type: Boolean,
      default: false,
    }, 'panel-styles': {
      type: String,
    },
  },
  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 3000);
    this.$refs.tree.select(this.task.subs[0]);
    this.selected = this.task.subs[0];
  },
  computed: {
    ...mapGetters('session', ['session']),
    nodes() {
      return this.panels;
    },
    views() {
      const _views = [{
        key: 'task',
        name: '执行',
        icon: 'md-create',
      }, {
        key: 'flow',
        name: '流程',
        icon: 'lianjieliu',
      }, {
        key: 'gantte',
        name: '管理',
        icon: 'xiangmu',
      }, {
        key: 'file',
        name: '资料',
        icon: 'folder',
      }, {
        key: 'share',
        name: '分享',
        icon: 'share1',
      }];
      let o = _views;
      if (!this.selected.flow) {
        o = o.filter((v) => v.key != 'flow');
        if (!this.subs || this.subs.length == 0) {
          o = o.filter((v) => v.key != 'gantte');
        }
      }

      return o;
    },

    admin() {
      return this.role == 'admin';
    },
    permissions() {
      if (this.role == 'admin') {
        return true;
      } else {
        return {

        };
      }
    },
  },
  methods: {
    handleTreeEvent(e) {
      if (e.type == 'select') {
        this.selected = e.data;
      }
    },
    handleEvent(e) {
      this.$emit('event', e);
    },
    renderTreeNode(h, node) {
      const key = h('BaseIcon', {props: {icon: 'md-key', size: '18', color: 'var(--primary)'}, style: 'margin-right:5px;'});
      const tools = node.control ? [] : [h('BaseIcon', {props: {icon: 'dot', size: '15', color: 'var(--primary)'}, style: 'position:absolute;right:0;'})];
      const leftDom = h('div', {class: 'flex-wrap'}, [key, node.name]);
      return h('div', {class: 'flex-wrap flex-between', style: 'height:25px;'}, [leftDom, tools]);
    },
  },
};
</script>

<style lang="less">
.pm-panel-flex {
  display: flex;
}
.pm-panel-editing-wrap:hover {
  filter: brightness(1.2);
  cursor: pointer;
}

.pm-panel-selected {
  background: #fbbd2162 !important;
}
</style>
